var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/sms"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3335 2.33398H4.66683C2.66683 2.33398 1.3335 3.33398 1.3335 5.66732V10.334C1.3335 12.6673 2.66683 13.6673 4.66683 13.6673H11.3335C13.3335 13.6673 14.6668 12.6673 14.6668 10.334V5.66732C14.6668 3.33398 13.3335 2.33398 11.3335 2.33398ZM11.6468 6.39398L9.56016 8.06065C9.12016 8.41398 8.56016 8.58732 8.00016 8.58732C7.44016 8.58732 6.8735 8.41398 6.44016 8.06065L4.3535 6.39398C4.14016 6.22065 4.10683 5.90065 4.2735 5.68732C4.44683 5.47398 4.76016 5.43398 4.9735 5.60732L7.06016 7.27398C7.56683 7.68065 8.42683 7.68065 8.9335 7.27398L11.0202 5.60732C11.2335 5.43398 11.5535 5.46732 11.7202 5.68732C11.8935 5.90065 11.8602 6.22065 11.6468 6.39398Z",
    fill: "#4F5054"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.3f5600562aafa060e6339407537b9148.svg";
export { ForwardRef as ReactComponent };